import { render, staticRenderFns } from "./VariationDescription.vue?vue&type=template&id=84de787a&"
import script from "./VariationDescription.vue?vue&type=script&lang=js&"
export * from "./VariationDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84de787a')) {
      api.createRecord('84de787a', component.options)
    } else {
      api.reload('84de787a', component.options)
    }
    module.hot.accept("./VariationDescription.vue?vue&type=template&id=84de787a&", function () {
      api.rerender('84de787a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/VariationDescription.vue"
export default component.exports